import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useErrors from '../hook/useErrors';
import server from '../services/server';
import PhoneInputMasked from './masks/PhoneInputMasked';
import DocumentInputMasked from './masks/DocumentInputMasked';
import { useNavigate, useParams } from 'react-router-dom';
import EnderecosListLayer from './EnderecosListLayer';


const getValidationSchema = () => Yup.object().shape({
    email: Yup.string().email('Email inválido').required('Email é obrigatório'),
    documento: Yup.string().nullable().required('Documento é obrigatório'),
    nome: Yup.string().nullable().test('nome-required', 'Nome completo é obrigatório', function (value) {
        if (!Boolean(this.parent.isJuridico)) {
            return Boolean(value?.trim());
        }
        return true;
    }),
    razaoSocial: Yup.string().nullable().test('razao-social-required', 'Razão Social é obrigatória', function (value) {
        if (Boolean(this.parent.isJuridico)) {
            return Boolean(value?.trim());
        }
        return true;
    }),
});

function ViewClienteLayer({ data, mutate, backTo = '/clientes' }) {
    const { id } = useParams();


    return (

            <div className='card'>
                <div className='card-body'>

                    <ul className="d-inline-flex nav nav-pills border-gradient-tab mb-20" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className="d-flex nav-link align-items-center active px-24"
                                id="pills-edit-debtors-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-edit-debtors"
                                type="button"
                                role="tab"
                                aria-controls="pills-edit-debtors"
                                aria-selected="true"
                            >
                                {!Boolean(id) ? 'Cadastrar Cliente' : 'Editar Cliente'}
                            </button>
                        </li>
                        {Boolean(id) && (
                            <li className="nav-item" role="presentation">
                                <button
                                    className="d-flex nav-link align-items-center px-24"
                                    id="pills-add-address-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-add-address"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-add-address"
                                    aria-selected="false"
                                    tabIndex={-1}
                                >
                                    Adicionar endereço
                                </button>
                            </li>
                        )}



                    </ul>

                    <div className="tab-content" id="pills-tabContent">
                        <DadosCliente data={data} mutate={mutate} backTo={backTo} />
                        {Boolean(id) && <EnderecosListLayer mutate={mutate} />}
                    </div>





                </div>
            </div >

    );
}

export default ViewClienteLayer;


function DadosCliente({ data, mutate, backTo }) {
    const { id } = useParams();
    const { setErrors, toast } = useErrors();
    const navigate = useNavigate();

    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, setFieldValue, touched, values, setValues } =
        useFormik({
            initialValues: {
                nome: '',
                email: '',
                telefone: '',
                endereco: '',
                documento: '',
                dataNascimento: '',
                status: true,
                isJuridico: false,
                razaoSocial: '',
                nomeFantasia: '',
                inscricaoEstadual: '',
                inscricaoMunicipal: '',
                site: '',
                nomeResponsavel: '',
                telefoneResponsavel: '',
                action: 'create',
            },
            validationSchema: getValidationSchema(),
            validateOnMount: false,
            validateOnChange: true,
            onSubmit: async (values, { setSubmitting }) => {
                try {
                    if (values.action === 'update') {
                        await server.put(`cliente/${values.id}`, values);
                        mutate();
                        toast.success('Cliente alterado com sucesso!');
                    }
                    if (values.action === 'create') {
                        const { data: novo } = await server.post('cliente', values);
                        toast.success('Cliente criado com sucesso!');
                        navigate(`/clientes/${novo?.id}`);
                    }
                    setSubmitting(false);
                } catch (error) {
                    setSubmitting(false);
                    setErrors(error);
                }
            },
        });

    useEffect(() => {
        if (Boolean(data)) {
            const dataFormatada = data.dataNascimento
                ? new Date(data.dataNascimento).toISOString().split('T')[0]
                : '';

            setValues({
                ...data,
                dataNascimento: dataFormatada,
                razaoSocial: data.razaoSocial || (data.isJuridico ? data.nome : '') || '',
                status: data.status ?? true,
                action: 'update',
            }, true);
        }
    }, [data]);

    useEffect(() => {
        if (id) {
            setFieldValue('action', 'update');
        }
    }, [id]);

    function handleCheckboxChange(e) {
        setFieldValue('status', e.target.checked);
    }

    function handleJuridicoChange(e) {
        const isJuridico = e.target.checked;
        setFieldValue('isJuridico', isJuridico);

        // Limpar campos específicos ao alternar
        if (isJuridico) {
            setFieldValue('nome', '');
            setFieldValue('dataNascimento', '');
        } else {
            setFieldValue('razaoSocial', '');
            setFieldValue('nomeFantasia', '');
            setFieldValue('inscricaoEstadual', '');
            setFieldValue('inscricaoMunicipal', '');
            setFieldValue('site', '');
            setFieldValue('nomeResponsavel', '');
            setFieldValue('telefoneResponsavel', '');
        }
    }
    return (
        <div className="active fade show tab-pane" id="pills-edit-debtors" role="tabpanel" aria-labelledby="pills-edit-debtors-tab" tabIndex={0}>


            <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                    <div className="mb-20 col-12">
                        <div className="form-switch switch-primary d-flex align-items-center gap-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switchJuridico"
                                checked={values.isJuridico}
                                onChange={handleJuridicoChange}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switchJuridico"
                            >
                                Cliente Jurídico (Pessoa Jurídica)
                            </label>
                        </div>
                    </div>

                    {!values.isJuridico ? (
                        <>
                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="nome" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Nome completo
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.nome && errors.nome && <span className="text-danger-600">{errors.nome}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="nome" placeholder="Nome completo" {...getFieldProps('nome')} />
                            </div>

                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="dataNascimento" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Data de Nascimento
                                    {touched.dataNascimento && errors.dataNascimento && <span className="text-danger-600">{errors.dataNascimento}</span>}
                                </label>
                                <input
                                    type="date"
                                    className="form-control radius-8"
                                    id="dataNascimento"
                                    placeholder="Data de Nascimento"
                                    {...getFieldProps('dataNascimento')}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="razaoSocial" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Razão Social
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.razaoSocial && errors.razaoSocial && <span className="text-danger-600">{errors.razaoSocial}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="razaoSocial" placeholder="Razão Social" {...getFieldProps('razaoSocial')} />
                            </div>

                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="nomeFantasia" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Nome Fantasia
                                    {touched.nomeFantasia && errors.nomeFantasia && <span className="text-danger-600">{errors.nomeFantasia}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="nomeFantasia" placeholder="Nome Fantasia" {...getFieldProps('nomeFantasia')} />
                            </div>

                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="inscricaoEstadual" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Inscrição Estadual
                                    {touched.inscricaoEstadual && errors.inscricaoEstadual && <span className="text-danger-600">{errors.inscricaoEstadual}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="inscricaoEstadual" placeholder="Inscrição Estadual" {...getFieldProps('inscricaoEstadual')} />
                            </div>

                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="inscricaoMunicipal" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Inscrição Municipal
                                    {touched.inscricaoMunicipal && errors.inscricaoMunicipal && <span className="text-danger-600">{errors.inscricaoMunicipal}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="inscricaoMunicipal" placeholder="Inscrição Municipal" {...getFieldProps('inscricaoMunicipal')} />
                            </div>

                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="site" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Site
                                    {touched.site && errors.site && <span className="text-danger-600">{errors.site}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="site" placeholder="https://www.exemplo.com.br" {...getFieldProps('site')} />
                            </div>

                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="nomeResponsavel" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Nome do Responsável
                                    {touched.nomeResponsavel && errors.nomeResponsavel && <span className="text-danger-600">{errors.nomeResponsavel}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="nomeResponsavel" placeholder="Nome do Responsável" {...getFieldProps('nomeResponsavel')} />
                            </div>

                            <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                                <label htmlFor="telefoneResponsavel" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Telefone do Responsável
                                    {touched.telefoneResponsavel && errors.telefoneResponsavel && <span className="text-danger-600">{errors.telefoneResponsavel}</span>}
                                </label>
                                <PhoneInputMasked
                                    className="form-control radius-8"
                                    id="telefoneResponsavel"
                                    placeholder="Telefone do Responsável"
                                    {...getFieldProps('telefoneResponsavel')}
                                />
                            </div>
                        </>
                    )}

                    <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                        <label htmlFor="email" className="form-label text-primary-light text-sm fw-semibold mb-8">
                            Email
                            <span className="text-danger-600">*</span>{' '}
                            {touched.email && errors.email && <span className="text-danger-600">{errors.email}</span>}
                        </label>
                        <input type="email" className="form-control radius-8" id="email" placeholder="Email" {...getFieldProps('email')} />
                    </div>

                    <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                        <label className="form-label text-primary-light text-sm fw-semibold mb-8">
                            Documento - {values.isJuridico ? 'CNPJ' : 'CPF'}
                            <span className="text-danger-600">*</span>{' '}
                            {touched.documento && errors.documento && <span className="text-danger-600">{errors.documento}</span>}
                        </label>
                        <div className="position-relative">
                            <DocumentInputMasked
                                className={`form-control wizard-required ${touched.documento && errors.documento ? 'is-invalid' : ''}`}
                                placeholder={values.isJuridico ? 'CNPJ' : 'CPF'}
                                {...getFieldProps('documento')}
                            />
                            <div className="wizard-form-error" />
                        </div>
                    </div>

                    <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                        <label htmlFor="telefone" className="form-label text-primary-light text-sm fw-semibold mb-8">
                            Telefone
                            {touched.telefone && errors.telefone && <span className="text-danger-600">{errors.telefone}</span>}
                        </label>
                        <PhoneInputMasked
                            className="form-control radius-8"
                            id="telefone"
                            placeholder="Telefone"
                            {...getFieldProps('telefone')}
                        />
                    </div>
                </div>
                <footer className="d-flex card-footer bg-white align-items-cent justify-content-end gap-3 mt-10">
                    <div className="form-switch  switch-primary   d-flex align-items-center gap-3">

                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch2"
                            checked={Boolean(values.status)}
                            onChange={handleCheckboxChange}
                        />
                        <label
                            className="form-check-label line-height-1 fw-medium text-secondary-light"
                            htmlFor="switch2"
                        >
                            Ativo
                        </label>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary border border-primary-600 text-sm px-24 py-8 radius-8"
                        onClick={() => navigate(backTo)}
                    >
                        Voltar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-success border border-success text-sm px-24 py-8 radius-8"
                        disabled={isSubmitting || !isValid}
                    >
                        {isSubmitting ? 'Salvando...' : 'Salvar'}
                    </button>
                </footer>
            </form>
        </div>

    )
}
